import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import Link from "@/Layouts/Link";

function MobileSubMenu(props) {
    const {stores = {}, soulSubMenu = []} = props;
    const {subMenuStore = {}, mobileMenuStore = {}} = stores;

    let element = soulSubMenu.map((el) => {
        return <div key={el.id} className={`nav__item`}>
            <Link href={`${el.link}`}
                  onClick={() => mobileMenuStore.closeMobileMenu()}
            >
                {el.name}
            </Link>
        </div>
    });

    return <>
        <div onClick={() => subMenuStore.goBackToMenu('soul')}
             className={`nav__item`}>
            Назад
        </div>
        {element.length !== 0 && (element)}
    </>
}

export default useWithStore(MobileSubMenu)
